import React, { Component, useEffect, useState } from "react"
// import { Flipper } from "react-flip-toolkit"
// import DropdownContainer from "./DropdownContainer"
// import { Icon, DropdownSection, Heading } from "./DropdownContents/Components.js"
import { BiCategoryAlt, BiChevronLeft, BiChevronRight } from "react-icons/bi";
import * as rsuite from 'rsuite'
import styled from "styled-components"
import * as General from '../General/General.js'
import * as BiIcon from "react-icons/bi"
import { useNavigate } from 'react-router-dom'
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';
import Layout from '../../Layout/CustomerLayout.js';
import persianJs from 'persianjs';




// import InputMask from "react-input-mask";




const UserLogin = (props) => {
    const navigate = useNavigate();
    const toaster = rsuite.useToaster();
    const [InterMobileNo, setInterMobileNo] = React.useState(true);
    const [InterUserDetaile, setInterUserDetaile] = React.useState(true);
    const [InterActiveCode, setInterActiveCode] = React.useState(false);
    const [FirstName, setFirstName] = React.useState("");
    const [LastName, setLastName] = React.useState("");
    const [Mobile, setMobile] = React.useState("");
    const [ActiveCode, setActiveCode] = React.useState("");
    const [UserDate, setUserDate] = React.useState("");
    const [CreateAccountState, setCreateAccountState] = React.useState(false);
    const [Min, setMin] = React.useState(0);
    const [Sec, setSec] = React.useState(0);
    let MyInterval = null;
    var distance = 120000;
    const [CreateUserMin, setCreateUserMin] = React.useState(0);
    const [CreateUserSec, setCreateUserSec] = React.useState(0);
    let MyCreateUserInterval = null;
    var CreateUserdistance = 120000;

    const Mobile_Change = (e) => {
        if (e == "" || e == null)
            setMobile(e)
        else
            setMobile(persianJs(e).toEnglishNumber()._str)
    }



    const ActiveCode_Change = (e) => {
        if (e == "" || e == null)
            setActiveCode(e)
        else
            setActiveCode(persianJs(e).toEnglishNumber()._str)
    }

    const GetActiveCode = () => {

        if (Mobile == "" || Mobile.length != 11 || Mobile.substring(0, 2) != "09") {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("شماره همراه را به درستی وارد کنید")), 'topCenter')
        }
        else {
            var RequestOptions = {
                data: {
                    "Mobile": Mobile,
                    // "Count": Count,
                    // "Title": Title
                },
                url: General.ApiRoute() + "/Online_Customer/GetActiveCode",
                method: "post",
                withCredentials: true,

                headers: {
                    'ApiKey': General.APIKey(),
                    'Content-Type': 'application/json'
                }
            }
            trackPromise(
                axios(RequestOptions)
                    .then(function (result) {

                        if (result.data.includes("OK")) {
                            setInterActiveCode(true);
                            setInterMobileNo(false)
                            setUserDate(result.data)
                            Bind_Timer();
                            MyInterval = null;
                            distance = 120000;

                            // toaster.push(General.ShowMessage('success', General.SuccessMessage(Id.split("|")[1] +  " با موفقیت به سبد خرید شما اضافه شد . ")), 'topCenter')
                        }
                        else {
                            toaster.push(General.ShowMessage('error', General.ErrorMessage(result.data)), 'topCenter')
                        }

                    }).catch((error) => {
                        console.log(error);
                        console.log(error.response);
                        console.log(error.response?.data);

                        toaster.push(
                            General.ShowMessage(
                                'error',
                                General.ErrorMessage(error.response?.data || error.message)
                            ),
                            'topCenter'
                        );
                    })
            )

        }
    }

    const CheckActiveCode = () => {
        if (UserDate.split("|")[3] * 1 == ActiveCode * 1) {
            localStorage.setItem("UserFullNameFarmAsan", UserDate.split("|")[1])
            localStorage.setItem("CustomerFarmAsanId", UserDate.split("|")[2])
            localStorage.setItem("IsSupplierFarmAsanId", UserDate.split("|")[4])
            // localStorage.setItem("IsSupplierFarmAsanId", 1)
            setInterMobileNo(false);
            setInterActiveCode(false);
        }
        else {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("کد فعال سازی اشتباه می باشد")), 'topCenter')
        }
    }

    const CreateAccount = () => {
        setCreateAccountState(true);
        setInterUserDetaile(true);
        setFirstName("");
        setLastName("");
        setMobile("");
    }


    const GetActiveCodeForCreateUser = () => {
        if (FirstName == "" || LastName == "" || Mobile == "" || Mobile.length != 11 || Mobile.substring(0, 2) != "09") {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("اطلاعات خود را کامل وارد کنید")), 'topCenter')
            return;
        }
        else {
            var RequestOptions = {
                data: {
                    "Mobile": Mobile,
                    // "Count": Count,
                    // "Title": Title
                },
                url: General.ApiRoute() + "/Online_Customer/GetActiveCodeForCreateUser",
                method: "post",
                withCredentials: true,

                headers: {
                    'ApiKey': General.APIKey(),
                    'Content-Type': 'application/json'
                }
            }
            trackPromise(
                axios(RequestOptions)
                    .then(function (result) {

                        if (result.data.includes("OK")) {
                            setActiveCode();
                            setUserDate(result.data);
                            setInterUserDetaile(false);
                            setInterActiveCode(true)
                            if (result.data.includes("OKExist")) {
                                setCreateAccountState(false);
                                setInterMobileNo(false);
                                Bind_Timer();
                                MyInterval = null;
                                distance = 120000;

                            }
                            else {
                                Bind_CreateUserTimer();
                                MyCreateUserInterval = null;
                                CreateUserdistance = 120000;

                            }

                        }
                        else {
                            toaster.push(General.ShowMessage('error', General.ErrorMessage(result.data)), 'topCenter')
                        }

                    }).catch((error) => {
                        console.log(error);
                        console.log(error.response);
                        console.log(error.response?.data);

                        toaster.push(
                            General.ShowMessage(
                                'error',
                                General.ErrorMessage(error.response?.data || error.message)
                            ),
                            'topCenter'
                        );
                    })
            )

        }
    }

    const Save = () => {
        if (UserDate.split("|")[1] * 1 == ActiveCode * 1) {


            var RequestOptions = {
                data: {
                    "FirstName": FirstName,
                    "LastName": LastName,
                    "Mobile": Mobile,
                    "ActiveCode": ActiveCode,


                },
                url: General.ApiRoute() + "/Online_Customer/CreateUserFromWeb",
                method: "post",
                withCredentials: true,

                headers: {
                    'ApiKey': General.APIKey(),
                    'Content-Type': 'application/json',
                }
            }
            trackPromise(
                axios(RequestOptions)
                    .then(function (result) {
                        if (result.data.includes("OK")) {
                            toaster.push(General.ShowMessage('success', General.SuccessMessage(" اطلاعات با موفقیت ثبت گردید . ")), 'topCenter')
                            setCreateAccountState(false);
                            localStorage.setItem("UserFullNameFarmAsan", result.data.split("|")[1])
                            localStorage.setItem("CustomerFarmAsanId", result.data.split("|")[2])
                            localStorage.setItem("IsSupplierFarmAsanId", 0)
                            // localStorage.setItem("IsSupplierFarmAsanId", 1)
                            setInterMobileNo(false);
                            setInterActiveCode(false);
                        }
                        else {
                            toaster.push(General.ShowMessage('error', General.ErrorMessage(result.data)), 'topCenter')
                        }

                    }).catch((error) => {
                        console.log(error);
                        console.log(error.response);
                        console.log(error.response?.data);

                        toaster.push(
                            General.ShowMessage(
                                'error',
                                General.ErrorMessage(error.response?.data || error.message)
                            ),
                            'topCenter'
                        );
                    })
            )
        }
        else {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("کد فعال سازی اشتباه می باشد")), 'topCenter')
        }
    }



    const Bind_Timer = () => {

        MyInterval = setInterval(function () {

            distance = distance - 1000;
            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);
            console.dir("minutes" + minutes)
            console.dir("seconds" + seconds)
            if (distance <= 0 || (minutes == 0 && seconds == 0)) {
                clearInterval(MyInterval)
                setSec(0);
                setMin(0);
            }

            else {

                if (minutes > 0) {
                    setMin(minutes.toString())
                }
                else {

                    setMin((0).toString());
                }

                if (seconds > 0) {
                    setSec(seconds.toString())
                }
                else {
                    setSec((0).toString());
                }
            }

        }, 1000)
    }

    const Bind_CreateUserTimer = () => {

        MyCreateUserInterval = setInterval(function () {

            CreateUserdistance = CreateUserdistance - 1000;
            var minutes = Math.floor((CreateUserdistance % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((CreateUserdistance % (1000 * 60)) / 1000);
            console.dir("minutes" + minutes)
            console.dir("seconds" + seconds)
            if (distance <= 0 || (minutes == 0 && seconds == 0)) {
                clearInterval(MyInterval)
                setCreateUserSec(0);
                setCreateUserMin(0);
            }

            else {

                if (minutes > 0) {
                    setCreateUserMin(minutes.toString())
                }
                else {

                    setCreateUserMin((0).toString());
                }

                if (seconds > 0) {
                    setCreateUserSec(seconds.toString())
                }
                else {
                    setCreateUserSec((0).toString());
                }
            }

        }, 1000)
    }


    const ShowFactorHistory = () => {
        window.location.href = "/FactorHistory";

    }
    const ShowBuyFactorHistory = () => {
        window.location.href = "/BuyFactorHistory";

    }
    const ShowPaymentSuccess = () => {
        window.location.href = "/PaymentSuccess";

    }

    const Back=()=>{
        window.location.href=localStorage.getItem("FarmBackPageFromLoging")
    }


    React.useEffect(() => {
        if (localStorage.getItem("UserFullNameFarmAsan") == null) {
            setInterMobileNo(true)
            setInterActiveCode(false)
        }
        setCreateAccountState(false);
        document.title = "FarmAsan.ir ";
    }, [])


    return (
        <Layout title={"حساب کاربری"} >
            <rsuite.Row className={CreateAccountState == false ? "justify-content-center align-items-center pb-4 mb-4 m-2" : "hide"}>
                {localStorage.getItem("CustomerFarmAsanId") == null ?
                    <rsuite.Col xs={24}>
                        <rsuite.Row className={InterMobileNo ? "" : "hide"}>
                            <rsuite.Col xsHidden smHidden md={6} ></rsuite.Col>
                            <rsuite.Col xs={24} md={12} className="mt-5 pt-5 text-center Font17">
                                <b>شماره همراه خود را وارد نمایید  </b>
                                <rsuite.Input type="number" maxLength={11} className="p-3 m-3 border" placeholder="09xxxxxxxxx" value={Mobile} onChange={(e) => Mobile_Change(e)} ></rsuite.Input>
                            </rsuite.Col>
                            <rsuite.Col xsHidden smHidden md={6}></rsuite.Col>
                        </rsuite.Row>
                        <rsuite.Row className={InterMobileNo ? "" : "hide"}>
                            <rsuite.Col xsHidden xlHidden md={6} ></rsuite.Col>

                            <rsuite.Col xs={12} md={6} className="p-2">
                                <rsuite.Button color="green" onClick={() => GetActiveCode()} className=" me-3 ml-3 p-4 Font17" size="lg" block appearance="primary">
                                    دریافت کد فعال سازی
                                </rsuite.Button>
                            </rsuite.Col>
                            <rsuite.Col xs={12} md={6} className="p-2">
                                <rsuite.Button color="red" onClick={() => CreateAccount()} className=" me-3 ml-3 p-4 Font17" size="lg" block appearance="primary">
                                    حساب کاربری ندارم !
                                </rsuite.Button>
                            </rsuite.Col>

                            <rsuite.Col xsHidden xlHidden md={6} ></rsuite.Col>


                        </rsuite.Row>
                        <rsuite.Row className={InterActiveCode ? "" : "hide"}>
                            <rsuite.Col xsHidden xlHidden md={6} ></rsuite.Col>
                            <rsuite.Col xs={24} md={12} className="mt-5 pt-5 text-center Font17">
                                <b>کد فعال سازی را وارد کنید</b>
                                <rsuite.Input type="number" maxLength={5} className="p-3 m-3 border" placeholder="XXXXX" value={ActiveCode} onChange={(e) => ActiveCode_Change(e)} ></rsuite.Input>
                            </rsuite.Col>
                            <rsuite.Col xsHidden xlHidden md={6} ></rsuite.Col>
                        </rsuite.Row>
                        <rsuite.Row className={InterActiveCode ? "" : "hide"}>
                            <rsuite.Col xsHidden xlHidden md={6} ></rsuite.Col>

                            <rsuite.Col xs={12} md={6} className="p-2">
                                <rsuite.Button color="green" onClick={() => CheckActiveCode()} className="border border-2 me-3 ml-3 p-4 Font17" size="lg" block appearance="primary">
                                    صحت سنجی کد فعال سازی
                                </rsuite.Button>
                            </rsuite.Col>
                            <rsuite.Col xs={12} md={6} className="p-2">
                                <rsuite.Button disabled={Sec == 0 && Min == 0 ? false : true} color="red" onClick={() => GetActiveCode()} className="border border-2 me-3 ml-3  p-4 Font17" size="lg" block appearance="primary">
                                    {Sec == 0 && Min == 0 ?
                                        <>
                                            ارسال مجدد کد!

                                        </>
                                        :
                                        <>
                                            {Sec} : {Min}

                                        </>
                                    }
                                </rsuite.Button>
                            </rsuite.Col>

                            <rsuite.Col xsHidden xlHidden md={6} ></rsuite.Col>


                        </rsuite.Row>

                    </rsuite.Col>
                    :
                    <rsuite.Row className="m-2">
                        <rsuite.Col xsHidden xlHidden md={6} ></rsuite.Col>
                        <rsuite.Col xs={24} md={12} className="mt-5 pt-5 text-center Font17">
                            <rsuite.Row>

                                <rsuite.Col xs={24}>
                                    {/* <rsuite.Heading level={2} >
                                        ارتباط با ما
                                    </rsuite.Heading> */}
                                    <b className="mt-4 Font17">
                                        علت ارتباط با فارم آسان را انتخاب کنید
                                    </b>
                                </rsuite.Col>
                                <rsuite.Col xs={24} className="p-2">
                                    <rsuite.Button color="green" className="border border-2  p-4 Font17" size="lg" block appearance="primary">
                                        خدمات پس از فروش
                                    </rsuite.Button>
                                </rsuite.Col>
                                <rsuite.Col xs={24} m className="p-2">
                                    <rsuite.Button color="green" className="border border-2  p-4 Font17" onClick={() => ShowFactorHistory()} size="lg" block appearance="primary">
                                        سابقه خرید کالا
                                    </rsuite.Button>
                                </rsuite.Col>
                                {localStorage.getItem("IsSupplierFarmAsanId") == 1 || localStorage.getItem("IsSupplierFarmAsanId") == "1" ?
                                    <rsuite.Col
                                        xs={24} className="p-2">
                                        <rsuite.Button color="green" className="border border-2  p-4 Font17" onClick={() => ShowBuyFactorHistory()} size="lg" block appearance="primary">
                                            سابقه فروش کالا
                                        </rsuite.Button>
                                    </rsuite.Col>
                                    :
                                    <></>
                                }
                                <rsuite.Col xs={24} className="p-2">
                                    <rsuite.Button color="green" className="border border-2  p-4 Font17" size="lg" block appearance="primary" onClick={() => ShowPaymentSuccess()}>
                                        پیگیری سفارش
                                    </rsuite.Button>
                                </rsuite.Col>
                                <rsuite.Col xs={24} className="p-2">
                                    <rsuite.Button color="red" className="border border-2   Font17" size="lg" block appearance="primary" onClick={() => Back()}>
                                        بازگشت به :  {localStorage.getItem("FarmBackPageTitle")}
                                    </rsuite.Button>
                                </rsuite.Col>
                            </rsuite.Row>
                        </rsuite.Col>
                        <rsuite.Col xsHidden xlHidden md={6} ></rsuite.Col>


                    </rsuite.Row>
                }
            </rsuite.Row>
            <rsuite.Row className={CreateAccountState == true ? "justify-content-center align-items-center pb-4 mb-4 m-2" : "hide"}>
                <rsuite.Row className={InterUserDetaile == true ? "" : "hide"}>
                    <rsuite.Col xsHidden xlHidden md={6} ></rsuite.Col>
                    <rsuite.Col xs={24} md={12} className="mt-5 pt-5 ">

                        <row>
                            <rsuite.Col xs={24} md={24} className=" Font13">

                                <b>نام : </b>
                                <rsuite.Input className="p-3 border" value={FirstName} onChange={(e) => setFirstName(e)} ></rsuite.Input>
                            </rsuite.Col>
                            <rsuite.Col xs={24} md={24} className="mt-2 Font13">

                                <b>نام خانوادگی : </b>
                                <rsuite.Input className="p-3  border" value={LastName} onChange={(e) => setLastName(e)} ></rsuite.Input>
                            </rsuite.Col>
                            <rsuite.Col xs={24} md={24} className="mt-2 Font13">

                                <b>شماره همراه : </b>
                                <rsuite.Input type="number" maxLength={11} className="p-3  border" placeholder="09xxxxxxxxx" value={Mobile} onChange={(e) => setMobile(e)} ></rsuite.Input>
                            </rsuite.Col>
                            <rsuite.Col xs={24} md={24} className="mt-4 ">
                                <rsuite.Button color="green" onClick={() => GetActiveCodeForCreateUser()} className=" p-4 Font17" size="lg" block appearance="primary">
                                    ثبت و دریافت کد فعال سازی
                                </rsuite.Button>
                            </rsuite.Col>
                        </row>
                    </rsuite.Col>
                    <rsuite.Col xsHidden xlHidden md={6}></rsuite.Col>
                </rsuite.Row>

                <rsuite.Row className={InterActiveCode ? "" : "hide"}>
                    <rsuite.Col xsHidden xlHidden md={6} ></rsuite.Col>
                    <rsuite.Col xs={24} md={12} className="mt-5 pt-5 text-center Font17">
                        <b>کد فعال سازی را وارد کنید</b>
                        <rsuite.Input type="number" maxLength={5} className="p-3 m-3 border" placeholder="XXXXX" value={ActiveCode} onChange={(e) => ActiveCode_Change(e)} ></rsuite.Input>
                    </rsuite.Col>
                    <rsuite.Col xsHidden xlHidden md={6} ></rsuite.Col>
                </rsuite.Row>
                <rsuite.Row className={InterActiveCode ? "" : "hide"}>
                    <rsuite.Col xsHidden xlHidden md={6} ></rsuite.Col>

                    <rsuite.Col xs={12} md={6} className="p-2">
                        <rsuite.Button color="green" onClick={() => Save()} className="border border-2 me-3 ml-3 p-4 Font17" size="lg" block appearance="primary">
                            صحت سنجی کد فعال سازی
                        </rsuite.Button>
                    </rsuite.Col>
                    <rsuite.Col xs={12} md={6} className="p-2">
                        <rsuite.Button disabled={CreateUserSec == 0 && CreateUserMin == 0 ? false : true} color="red" onClick={() => GetActiveCodeForCreateUser()} className="border border-2 me-3 ml-3  p-4 Font17" size="lg" block appearance="primary">
                            {CreateUserSec == 0 && CreateUserMin == 0 ?
                                <>
                                    ارسال مجدد کد!

                                </>
                                :
                                <>
                                    {CreateUserSec} : {CreateUserMin}

                                </>
                            }
                        </rsuite.Button>
                    </rsuite.Col>

                    <rsuite.Col xsHidden xlHidden md={6} ></rsuite.Col>


                </rsuite.Row>
            </rsuite.Row>

        </Layout >
    )

}

export default UserLogin;



